<template lang="pug">
  v-card.elevation-0(class="mx-auto" width="256")
    ProfileDialog(v-if="showProfileDialog" :show="showProfileDialog" @close="onCloseProfileDialog")
    div.pl-4.py-4 {{userLoggedIn.fullName}}
    v-divider
    v-list(nav v-for="(link, idx) in links" :key="idx" class="list")
      v-list-item-group(color="primary")
        v-list-item(@click="onClickItem(link)")
          v-list-item-icon
            v-icon {{link.icon}}
          v-list-item-content
            v-list-item-title {{ $t(link.name) }}



</template>

<script lang="ts">
import Vue from 'vue'
import { USER_LOGGED_IN } from '@/store/getter-types'
import { CurrentUser } from '@/model/CurrentUser'
import { AUTH_LOG_USER_OUT } from '@/store/action-types'
import ProfileDialog from "@/components/user/ProfileDialog.vue";

interface ComponentData {
  showProfileDialog: boolean
}

export default Vue.extend({
    name: 'UserDropDown',
  components: {
    ProfileDialog
  },

    computed: {
      userLoggedIn(): CurrentUser{
        return this.$store.getters[USER_LOGGED_IN]
      },

    },
    methods: {
         onClickItem( item:any): void {

            if(item && item.code == "logout")
            {
              this.showDropDown = false

              this.$store.dispatch(AUTH_LOG_USER_OUT)
              this.$router.push('/login')
            }
            else if(item && item.code == "profile") {
                this.showProfileDialog = true
                this.showDropDown = false

            }
         },

        onShowProfileDialogClick () {
             this.showProfileDialog = true
        },

        onCloseProfileDialog() {
          this.showProfileDialog = false
        },

    },

    data (): any {
      return {
        showProfileDialog: false,
        showDropDown: false,
        links: [
          {
            name: 'profileDialog.ProfileTitle',
            code: "profile",
            icon: 'fa-user-circle'
          },
          {
            name: 'loginPage.logout',
            code: "logout",
            icon: 'fa-power-off'
          },

        ]
      };
    },

})
</script>

<style lang="stylus" scoped>

  .userdropdown
  {
    flex 1
    padding-top 9px
  }

  .username
  {
    display inline-flex
    padding 0 10px
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .f6 {
    font-size: 0.875rem;
  }
  .mr2 {

  }
  .ph3 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .pv1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .black-40 {
    color: rgba(0, 0, 0, 0.4);
  }
  .w4 {

  }

  .mt1 {
    margin-top: 0.25rem;
  }

  .mh2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .w2 {
    width: 2rem;
  }
  .h2 {
    height: 2rem;
  }
  .br-100 {
    border-radius: 100%;
  }
  .b--black-10 {
    border-color: rgba(0, 0, 0, 0.1);
  }
  .ba {
    border-style: solid;
    border-width: 1px;
  }

  .menu
  {
    background-color: #f4f4f4;
    border-style: solid;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-width: 0.125rem;
    border-color: rgba(0, 0, 0, 0.2);
    color: rgba(255, 255, 255, 0.8);
    border-radius: 0.25rem;
  }
  .ma0 {
    margin: 0;
  }
  .pl0 {
    padding-left: 0;
  }
  .pa0 {
    padding: 0;
    padding-left: 0px;
  }
  .list {
    list-style-type: none;
  }
  .menu li:not(:last-child){
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.3);
  }

  .menu li {
    border-style: solid;
    border-width: 1px;
    border-top-width: 1px;
    border-right-width: 1px;
    border-left-width: 1px;
    border-left-width: 0;
    border-top-width: 0;
    border-right-width: 0;
  }
  .dd-link {
    font-size: 0.875rem;
    padding: 0.5rem;
    text-decoration: none;
    transition: color 0.15s ease-in;
    opacity: 1;
    transition: opacity 0.15s ease-in;
    width: 100%;
    height: 100%;
    display: inline-block;
    border-color: rgba(255, 255, 255, 0.1);
    color: rgba(0, 0, 0, 0.8);
  }

  .dd-link:hover
  {
    background-color: #cfcfcf
  }

  .link:link, .link:visited {
    transition: color 0.15s ease-in;
  }

  @media screen and (max-width: 400px)

    .username
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width 60px
</style>
